import { render, staticRenderFns } from "./ConsultaNfseNacional.vue?vue&type=template&id=5ffc0771&"
import script from "./ConsultaNfseNacional.vue?vue&type=script&lang=js&"
export * from "./ConsultaNfseNacional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports